import matchingImage from "../../assets/drone.webp";

const points = [
  {
    title: "Reads the file",
    description: "Loan type, ticket size, borrower profile, city.",
  },
  {
    title: "Decides the desk",
    description:
      "Finverse's own book if the risk fits; otherwise a partner.",
  },
  {
    title: "Ranks lenders",
    description:
      "Ordered by approval likelihood for that exact profile.",
  },
  {
    title: "Reroutes",
    description:
      "A rejection moves the file down the list, not into a dead end.",
  },
];

function MatchingDetail() {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container grid min-h-[500px] grid-cols-1 items-center gap-12 md:gap-16 lg:grid-cols-[1.35fr_0.65fr]">

        {/* =====================================================
            CONTENT
        ====================================================== */}
        <div>
          
          {/* Label */}
          <p className="font-jakarta text-[11px] sm:text-[12px] font-medium tracking-[0.34em] text-[var(--mint-green)] uppercase mb-2.5">
            MATCHING, IN DETAIL
          </p>

          {/* Heading */}
          <h2 className="mt-4 font-bricolage text-[30px] sm:text-[36px] md:text-[40px] lg:text-[44px] font-bold leading-[1.12] tracking-[-1px] text-[#f4f7f5]">
            In-house first. Partner lender where it fits.
          </h2>

          {/* Points */}
          <ul className="mt-9 space-y-5 sm:mt-10 sm:space-y-5">
            {points.map((point) => (
              <li
                key={point.title}
                className="flex items-start gap-3 font-jakarta text-[14px] leading-[1.55] sm:text-[16px]"
              >
                {/* Arrow */}
                <span
                  aria-hidden="true"
                  className="mt-[2px] shrink-0 text-[var(--mint-green)]"
                >
                  →
                </span>

                {/* Text */}
                <p className="min-w-0 text-[#aeb6b2]">
                  <span className="font-semibold text-[#f1f4f2]">
                    {point.title}
                  </span>

                  <span className="text-[#aeb6b2]">
                    {" "}
                    — {point.description}
                  </span>
                </p>
              </li>
            ))}
          </ul>
        </div>

        {/* =====================================================
            IMAGE
        ====================================================== */}
        <div className="flex items-center justify-center lg:justify-end">
          <img
            src={matchingImage}
            alt="Lender matching network"
            className="w-[220px] object-contain sm:w-[260px] md:w-[280px] lg:w-[300px] xl:w-[320px]"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}

export default MatchingDetail;